import Api from './api'

const urlPath = "bookings"

export default {
    //GET
    getBookingList: (params = {}) => Api.GET(urlPath, params),
    getBookingDetails: (id) => Api.GET(`${urlPath}/${id}`, {}),

    //POST
    addBooking: (json) => Api.POST(`${urlPath}`, json),

    //PUT
    updateBooking: (json) => Api.PUT(`${urlPath}/${json.id}`, json)
}